<template>
    <div class="view-404 bg-light">
        <simbar-header />
        <main class="container">
            <h1>{{ message }}</h1>
            <b-button class="mt-3" variant="primary" :to="{ name: 'home' }">
                <i class="fas fa-fw fa-arrow-left" /> voltar para página inicial
            </b-button>
        </main>
        <simbar-footer />
    </div>
</template>
<script>
import SimbarHeader from "@/modules/dashboard/components/SimbarHeader";
import SimbarFooter from "@/modules/dashboard/components/SimbarFooter";

export default {
    name: "NotFound",
    components: {
        SimbarHeader,
        SimbarFooter
    },
    props: {
        message: {
            type: String,
            default: "Erro 404 - Página não encontrada."
        }
    }
};
</script>

<style lang="scss" scoped>
.view-404 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100%;
    padding-top: $navbar-height;

    main {
        flex-grow: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .btn {
            align-self: center;
        }
    }
}
</style>
